import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import Link from 'next/link'

import { chooseTiles } from '@/constants/home'

export const Choose: FC = (): ReactNode => {
    return (
        <section id='book' className='shell pb-20 md:pb-28 lg:pb-32'>
            <div
                className='grid gap-5 md:grid-cols-2'
                data-reveal-group
                data-reveal-stagger='0.14'
            >
                {chooseTiles.map((tile) => (
                    <Link
                        key={tile.title}
                        href={tile.href}
                        className='group relative isolate flex min-h-[320px] items-end overflow-hidden rounded-[10px] bg-ink p-7 md:min-h-[380px] md:p-9'
                        data-reveal='up'
                    >
                        <div className='absolute inset-0 -z-10'>
                            <div className='absolute left-0 top-0 h-full w-full' data-parallax='20'>
                                <Image
                                    src={tile.image}
                                    alt={tile.alt}
                                    fill
                                    sizes='(max-width: 768px) 100vw, 50vw'
                                    className='object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105'
                                />
                            </div>

                            <div aria-hidden='true' className='absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/30 to-transparent' />
                        </div>

                        <div>
                            <p className='t-eyebrow text-cream/70'>
                                {tile.eyebrow}
                            </p>

                            <h3 className='t-h2 mt-2 text-cream'>
                                {tile.title}
                            </h3>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    )
}
